import { Component } from '@angular/core';
import {ViewController, NavParams, ModalController} from 'ionic-angular';

import { DataProvider } from '../../providers/data/data';
import { HelperProvider } from '../../providers/helper/helper';
import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';
import {LoadingPage} from "../loading/loading";
import { ConstantsProvider } from '../../providers/constants/constants';

@Component({

   selector: 'page-popover-queue',
   templateUrl: 'popover-queue.html'
})

export class PopoverQueuePage
{
   private today;
   private initVal;
   private callback;

   private queues = [];


   /** ----- Constructor ----- **/

   constructor( private data: DataProvider,
                private constants: ConstantsProvider,
                private cloudData: CloudDataProvider,
                private modalCtrl: ModalController,
                private helper: HelperProvider,
                private viewCtrl: ViewController,
                private params: NavParams )
   {
      // get today date
      this.today = new Date();
      this.initVal = this.params.get( 'init' );
      this.callback = this.params.get( 'callback' );

      //this.queues = [ this.data.standbys, this.data.pendings ];
     let par = {'token': this.data.token, 'date': this.getApiDate()};

     this.cloudData.getTickets((this.data.isPhy) ? 0 : 1, par).then(res => {
       if (res['status'] == true) {
           this.data.standbys = res['result']['standby'];
           this.data.pendings = res['result']['pending'];
           this.queues = [this.data.standbys,this.data.pendings ];
           console.log(this.queues);
       } else {
           console.log("讀取失敗");
       }

     });

   }

  getApiDate() {

    let dateStr = '';
    let monthStr = '' + (this.today.getMonth() + 1);
    if (monthStr.length == 1) monthStr = '0' + monthStr;
    let dayStr = '' + this.today.getDate();
    if (dayStr.length == 1) dayStr = '0' + dayStr;
    dateStr = this.today.getFullYear() + '-' + monthStr + '-' + dayStr;
    return dateStr;

  }


   /** ----- UI Callbacks ----- **/

   onBtnClicked( inIdx )
   {

      this.callback( inIdx ).then( () => {

         this.viewCtrl.dismiss();
      });

   }


   /** ----- Internal Methods ----- **/


   getTimeDisplay( inGrp, inIdx, ticket )
   {

      let tktId: number = -1;
      tktId = this.queues[inGrp][inIdx]['tkt_id'];
      let checkInTime = (this.data.checkins[tktId] != null) ? this.helper.tConvert( (this.data.checkins[tktId]['checkin_time']).split(" ")[1] ) : ticket.tkt_createtime.split(" ")[1];
      
      let tempTime = checkInTime.split(" ")[0].split(":");
      tempTime[0] = ((Number(tempTime[0]) + 8) % 24);
      tempTime[0] = tempTime[0] < 10 ? "0" + tempTime[0].toString() : tempTime[0].toString();
      let displayTime = this.helper.tConvert(tempTime.join(":"));
      return displayTime;

   }

   
   checkMed(inPatId) {
      if (this.constants.tempData[inPatId] != null) {
         let obj = this.constants.tempData[inPatId];
         let parsedObj = JSON.parse(obj);
         for (let i = 0; i < parsedObj.length; i++) {
            for (let j = 0; j < parsedObj[i]['data'].length; j++) {
               if (parsedObj[i]['data'][j]['type'] == 'disp-single' || parsedObj[i]['data'][j]['type'] == 'disp-grouped') {
                  return true;
               }
            }
         }
      }
      return false;
   }

   checkAcu(inPatId) {
      if (this.constants.tempData[inPatId] != null) {
         let obj = this.constants.tempData[inPatId];
         let parsedObj = JSON.parse(obj);
         for (let i = 0; i < parsedObj.length; i++) {
            for (let j = 0; j < parsedObj[i]['data'].length; j++) {
               if (parsedObj[i]['data'][j]['type'] == 'acu-single' || parsedObj[i]['data'][j]['type'] == 'acu-grouped') {
                  return true;
               }
            }
         }
      }
      return false;
   }

}



// WEBPACK FOOTER //
// ./src/pages/popover-queue/popover-queue.ts